module.exports = __webpack_public_path__ + "img/signal-app.827f68a1.png";